import { render, staticRenderFns } from "./ThemeSwitch.vue?vue&type=template&id=23f2ce28&scoped=true"
import script from "./ThemeSwitch.vue?vue&type=script&lang=js"
export * from "./ThemeSwitch.vue?vue&type=script&lang=js"
import style0 from "./ThemeSwitch.vue?vue&type=style&index=0&id=23f2ce28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f2ce28",
  null
  
)

export default component.exports